import { render, staticRenderFns } from "./startList.vue?vue&type=template&id=5fb480c4&scoped=true"
import script from "./startList.vue?vue&type=script&lang=js"
export * from "./startList.vue?vue&type=script&lang=js"
import style0 from "./startList.vue?vue&type=style&index=0&id=5fb480c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb480c4",
  null
  
)

export default component.exports